// import fetch from "auth/FetchInterceptor";
import { lossClient } from "api";

const JenisPengikatanCodeApprvService = {};

JenisPengikatanCodeApprvService.getJenisPengikatanCodeApprvList = function (
  userInput
) {
  return lossClient({
    url: "/JenisPengikatan/approvalItems?pageSize=1000&pageIndex=0",
    method: "get",
  });
};

export default JenisPengikatanCodeApprvService;
